import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum PanelReportsCampaignsResolverErrorStatesEnum {
    GetCampaignsFailed = ErrorStateScheduleEnum.PanelReportsCampaignsResolverErrorStatesStartIndex,
    GetCountriesFailed,
    GetPortalsFailed,
    GetTradingPlatformsFailed
}
